import {
    PermissionEnum,
    SiteRecceTypeEnum,
    SiteReccePriorityEnum,
    SiteRecceStatusEnum,
    SiteRecceTypeLabels,
    SiteReccePriorityLabels,
} from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { Table } from '@hyperflake/react-ui-library';
import { Chip } from '@library/chip';
import { useSiteRecceByStatusListData } from 'modules/site-recce/hooks/useSiteRecceByStatusListData';
import { useSiteRecceListData } from 'modules/site-recce/hooks/useSiteRecceListData';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';

interface SiteRecceByStatusListProps {
    status: SiteRecceStatusEnum;
}

export const SiteRecceByStatusList = (props: SiteRecceByStatusListProps) => {
    const { status } = props;
    const { hasPermission } = useAuthPermission();
    const navigate = useNavigate();

    const { siteRecceList, isLoading } = useSiteRecceByStatusListData(status);
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover
            isLoading={isLoading}
            data={siteRecceList}
            columns={[
                {
                    header: 'ID',
                },
                {
                    header: 'Type',
                },
                {
                    header: 'Client',
                },
                {
                    header: 'Project',
                },
                {
                    header: 'City',
                },
                {
                    header: 'Country',
                },

                // {
                //     header: 'Remarks',
                // },
                {
                    header: 'Priority',
                },

                {
                    header: 'Created At',
                },
                {
                    header: 'Created BY',
                },
            ]}
            renderRow={(row) => (
                <Table.Row
                    key={row._id}
                    onClick={() => {
                        if (hasPermission(PermissionEnum.SITE_RECCE_UPDATE)) {
                            navigate(
                                `/all-site-recce/edit?clientInstallationId=${row?.clientInstallation?._id}` +
                                    `&projectInstallationId=${row?.projectInstallation?._id}` +
                                    `&siteRecceId=${row._id}&status=${props.status}`
                            );
                        }
                    }}
                >
                    <Table.Cell>
                        {
                            // <Link
                            //     to={`/clients/${row._id}/client-details`}
                            //     // to=""
                            //     // /clients/10212/projects/21091/cctv-cameras/98673426/edit-cctv
                            // >
                            //     <div className="text-primary">{row._id}</div>
                            // </Link>
                            <div className="text-primary">
                                {row._id}
                                {/* <Link to={`/client-installations/add`}>{row._id}</Link> */}
                            </div>
                        }
                    </Table.Cell>
                    <Table.Cell>
                        {row.type
                            ? row.type
                            : // <Chip
                              //     label={SiteRecceTypeLabels[row.type]}
                              //     color={
                              //         row.type === SiteRecceTypeEnum.INITIAL_SITE_SURVEY
                              //             ? 'primary'
                              //             : row.type === SiteRecceTypeEnum.INSTALLATION
                              //             ? 'warning'
                              //             : row.type === SiteRecceTypeEnum.REMOVAL
                              //             ? 'danger'
                              //             : 'success'
                              //     }
                              //     variant="outlined"
                              // />
                              '-'}
                    </Table.Cell>
                    <Table.Cell>{row?.clientInstallation.name || '-'}</Table.Cell>
                    <Table.Cell>{row?.projectInstallation?.name || '-'}</Table.Cell>
                    <Table.Cell>{row?.projectInstallation.location.city || '-'}</Table.Cell>
                    <Table.Cell>{row?.projectInstallation.location.country || '-'}</Table.Cell>

                    {/* <Table.Cell>
                        <div className="max-w-[250px] truncate text-sm text-grayscale-800" title={row?.remarks}>
                            {row?.remarks}
                        </div>
                    </Table.Cell> */}

                    <Table.Cell>
                        <Chip
                            label={SiteReccePriorityLabels[row.priority]}
                            color={
                                row.priority === SiteReccePriorityEnum.HIGH
                                    ? 'danger'
                                    : row.priority === SiteReccePriorityEnum.MEDIUM
                                    ? 'warning'
                                    : 'success'
                            }
                            variant="shaded"
                        />
                    </Table.Cell>

                    <Table.Cell>{moment(row?.createdAt, 'YYYYMMDD').format('DD MMM, YYYY')}</Table.Cell>
                    <Table.Cell>{row?.createdBy?.name || '-'}</Table.Cell>
                </Table.Row>
            )}
        />
    );
};
